import React from 'react';
import './index.less';

/**
 * 会话切换时的骨架屏
 * 模拟用户消息（靠右）+ 助手消息（左侧图片网格占位）
 */
const MessageSkeleton = () => {
  return (
    <div className="messageSkeleton">
      {/* 用户消息骨架 - 靠右 */}
      <div className="skeletonRow userRow">
        <div className="skeletonBubble userBubble" />
      </div>

      {/* 助手消息骨架 - 靠左，含图片网格 */}
      <div className="skeletonRow assistantRow">
        <div className="skeletonImageGrid">
          <div className="skeletonImg" />
          <div className="skeletonImg" />
          <div className="skeletonImg" />
          <div className="skeletonImg" />
        </div>
        <div className="skeletonBubble assistantBubble" />
      </div>

      {/* 用户消息骨架 - 靠右 */}
      <div className="skeletonRow userRow">
        <div className="skeletonBubble userBubble short" />
      </div>
    </div>
  );
};

export default MessageSkeleton;
